export default "__VITE_PUBLIC_ASSET__4a01f4a9__"